// Generated by ReScript, PLEASE EDIT WITH CARE

import * as HashMap from "./HashMap.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";

function make(hasher) {
  return {
          hashMap: HashMap.make(hasher)
        };
}

function get(s, v) {
  var match = HashMap.get(s.hashMap, v);
  if (match !== undefined) {
    return Caml_option.some(v);
  }
  
}

function set(s, v) {
  return {
          hashMap: HashMap.set(s.hashMap, v, undefined)
        };
}

function remove(s, v) {
  return {
          hashMap: HashMap.remove(s.hashMap, v)
        };
}

function size(s) {
  return HashMap.size(s.hashMap);
}

export {
  make ,
  get ,
  set ,
  remove ,
  size ,
  
}
/* No side effect */
